export default "<app-loader *ngIf=\"isLoading$ | async\"></app-loader>\r\n<router-outlet></router-outlet>  "